import { useCallback } from 'react';

const NEXT = 'next';
const PREVIOUS = 'previous';

export const usePagination = ({ selectedPage, pages, setSelectedPage }) => {
  const navigateToPage = useCallback(
    (direction) => {
      if (!selectedPage || !pages.length) return;

      const currentIndex = pages.findIndex((p) => p.number === selectedPage.number);
      if (currentIndex === -1) return;

      let targetIndex;
      if (direction === NEXT && currentIndex < pages.length - 1) {
        targetIndex = currentIndex + 1;
      } else if (direction === PREVIOUS && currentIndex > 0) {
        targetIndex = currentIndex - 1;
      } else {
        return;
      }

      setSelectedPage(pages[targetIndex]);
    },
    [selectedPage, pages, setSelectedPage],
  );

  const nextPage = useCallback(() => navigateToPage(NEXT), [navigateToPage]);
  const previousPage = useCallback(() => navigateToPage(PREVIOUS), [navigateToPage]);

  return {
    nextPage,
    previousPage,
    navigateToPage,
  };
};
